import {Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import {formatModifyDate} from "../../../../../components/Common/CommonLogic";
import React from "react";


const ModalAirlineCharges = ({ viewData, modal, onCloseClick, modalType }) => {
    return(
        <>
            <Modal
                isOpen={modal}
                toggle={onCloseClick}
                className="table_view_modal"
                style={{ maxWidth: "1345px" }}>
                <ModalHeader tag="h4">
                    {modalType}
                    <span className="close" onClick={onCloseClick}></span>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <div className="row">
                                        {/* Charge Category */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Carrier Name</label>
                                            <span>{viewData?.carrierMaster?.name}</span>
                                        </div>

                                        {/* Port Name */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Agent Name<span className='required_star'>*</span></label>
                                            <span>{viewData?.tenantVendor?.name}</span>
                                        </div>

                                        {/* Terminal Name */}
                                        <div className="col-md-6 col-lg-4 mb-4">
                                            <label className="form-label">Booking Mode</label>
                                            <span>{viewData?.bookingModeType}</span>
                                        </div>

                                    </div>

                                    <hr />
                                    <div className="p-3"></div>
                                    <Card>
                                        <CardBody>
                                            {viewData?.vendorAirlineChargeValues?.map((chargeDetail, chargeIndex) => (
                                                <div className="row" key={`charge-${chargeIndex}`}>
                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">
                                                            Charge Code
                                                        </label>
                                                        <span>{chargeDetail?.surchargeCode?.description || ""}</span>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">
                                                            Charge Basis
                                                        </label>
                                                        <span>{chargeDetail?.unitOfMeasurement?.description || ""}</span>
                                                    </div>

                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">
                                                            Currency
                                                        </label>
                                                        <span>{chargeDetail?.currency?.currencyName || ""}</span>
                                                    </div>

                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">Validity From<span className='required_star'>*</span></label>
                                                        <span>{formatModifyDate(chargeDetail?.validFrom)}</span>
                                                    </div>

                                                    {/* Validity To */}
                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-12 mb-2">
                                                        <label className="form-label">Validity To<span className='required_star'>*</span></label>
                                                        <span>{formatModifyDate(chargeDetail?.validTo)}</span>
                                                    </div>
                                                    <hr />
                                                </div>
                                            ))}
                                        </CardBody>
                                    </Card>


                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    )
}

export default ModalAirlineCharges;
